import { render, staticRenderFns } from "./NotificationInformation.vue?vue&type=template&id=7b6feb3a&"
import script from "./NotificationInformation.vue?vue&type=script&lang=js&"
export * from "./NotificationInformation.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInformation.vue?vue&type=style&index=0&id=7b6feb3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports